import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconClapboardWide"><Path d="M22 17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V10H22V17.5Z" fill="currentColor"/><Path d="M6.60938 9H2V6.5C2 5.11929 3.11929 4 4.5 4H8.90137L6.60938 9Z" fill="currentColor"/><Path d="M13.9014 9H7.70801L10 4H16.1934L13.9014 9Z" fill="currentColor"/><Path d="M22 9H15L17.292 4H19.5C20.8807 4 22 5.11929 22 6.5V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboardWide;
